import {isDefined} from '@ls/js-utils';
import ScaleType from 'state/Constants/ScaleType';
import scope from './scope';
import CalcType from 'state/Constants/CalcType';

export default class FactorAttributionDefinition {
  static getDefault = () => new FactorAttributionDefinition({
    factorType: 'TOTAL',
    calcType: CalcType.Account,
    period: 'YTD',
    scaleType: ScaleType.Contribution
  });

  #factorType;
  #calcType;
  #period;
  #scaleType;

  constructor(props = {}) {
    const {factorType, calcType, period, scaleType} = props;
    this.#factorType = factorType;
    this.#calcType = calcType;
    this.#period = period;
    this.#scaleType = scaleType;
  }
  copy = () => ({
    factorType: this.#factorType,
    calcType: this.#calcType,
    period: this.#period,
    scaleType: this.#scaleType,
  });
  get factorType() {
    return this.#factorType;
  }
  get calcType() {
    return this.#calcType;
  }
  get period() {
    return this.#period;
  }
  get scaleType() {
    return this.#scaleType;
  }

  get key() {
    return `${scope} - ${this.#factorType}, ${this.#calcType}, ${this.#period}, ${this.#scaleType}`;
  }

  get complete() {
    return isDefined(this.#factorType) && isDefined(this.#calcType) && isDefined(this.#period) && isDefined(this.#scaleType);
  }
  setFactorType = (value) => new FactorAttributionDefinition({
    ...this.copy(),
    factorType: value,
  });
  setCalcType = (value) => new FactorAttributionDefinition({
    ...this.copy(),
    calcType: value,
  });
  setPeriod = (value) => new FactorAttributionDefinition({
    ...this.copy(),
    period: value,
  });
  setScaleType = (value) => new FactorAttributionDefinition({
    ...this.copy(),
    scaleType: value,
  });
}
